module.exports = __webpack_public_path__ + "img/6_105.64bb2d55.png";